<ng-container *transloco="let t">
  <pxw-modal-form
    #createVoucherModal
    [title]="title()"
    modalStyle="embeeded"
    [autoHeight]="false"
    [hideCloseButton]="false"
    modalClasses="create-voucher-modal"
  >
    <ng-template #modalContent>
      @if (voucherCreationQueue().length > 0) {
        <app-create-voucher-batch-errors [voucherCreationQueue]="voucherCreationQueue()" />
      } @else {
        @if (selectedOrders().length > 1) {
          <pxw-input-radio-group
            name="billingMode"
            [label]="t('Modo de facturación')"
            [helper]="
              t('Selecciona el modo de generación de las facturas para los pedidos seleccionados.')
            "
            [options]="billingModeOptions()"
            [(ngModel)]="billingMode"
            (ngModelChange)="onBillingModeChanged($event)"
            [valueKey]="'value'"
            [labelKey]="'label'"
          />
        }

        @if (displayCombinedBillingError()) {
          <pxw-alert type="danger" display="block" size="sm" style="margin-bottom: 2em">
            <span>{{
              t(
                'Para combinar múltiples pedidos en una única factura es necesario que todos los pedidos compartan los mismos datos de facturación.'
              )
            }}</span>
          </pxw-alert>
        } @else {
          @if (billingMode() === 'combined') {
            <pxw-input-checkbox
              name="mergeConceptsByOrder"
              [label]="t('Agrupación de conceptos')"
              [legend]="t('Agrupar los items/productos por pedido')"
              [helper]="t('Agrupar todos los conceptos de cada pedido en una sola línea')"
              [(ngModel)]="mergeConceptsByOrder"
            />
          }

          <pxw-input-text
            name="customConcept"
            [label]="t('Concepto personalizado')"
            [placeholder]="t('Dejá vacío para no agrupar conceptos')"
            [helper]="
              t(
                'Utilizar un único concepto para agrupar los items de cada pedido. Si se usa junto con la opción de combinar conceptos por pedido, este concepto se agregará junto al número de pedido.'
              )
            "
            [(ngModel)]="customConcept"
            [maxLength]="80"
          />

          <app-create-voucher-modal-preview
            [establishment]="establishment()"
            [electronicBillingIntegration]="electronicBillingIntegration()"
            [selectedOrders]="selectedOrders()"
            [groupingConceptName]="customConcept()"
            [groupByOrder]="mergeConceptsByOrder()"
            [billingMode]="billingMode()"
            [numberToVouchersToGenerate]="numberToVouchersToGenerate()"
          />
        }
      }
    </ng-template>
    <ng-template #modalFooter>
      @if (voucherCreationQueue().length > 0) {
        <pxw-button color="blue" size="md" [rounded]="true" (click)="modalForm().close()">
          {{ t('Listo') }}
        </pxw-button>
      } @else {
        <pxw-button
          color="blue"
          size="md"
          [rounded]="true"
          [disabled]="hasErrors()"
          [loading]="creatingVouchers()"
          (click)="onCreateVouchers()"
        >
          <pxw-icon icon="billing-voucher" />
          {{ title() }}
        </pxw-button>
      }
    </ng-template>
  </pxw-modal-form>
</ng-container>
